import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/etir-na-logo.png';

const Navbar = () => {

  const { t } = useTranslation();
  
  const authState = useSelector((state) => {
    return state.auth;
  });

  return (
    <nav className="navbar navbar-light bg-light">
      <div className="container-fluid">
        <div className="navbar-header">
          <Link className="navbar-brand" to="/"><img src={logo} height="24px" alt="eTIR National Application" /></Link>
          {/* <Link className="navbar-brand" to="/">{t('common:hdgAppName')}</Link> */}
          {/* <a href="/login/auth" type="button" className="btn btn-outline-primary navbar-btn navbar-right"><i className="fa fa-sign-in fa-lg" aria-hidden="true"></i> Log in</a> */}
        </div>
        <div className="navbar-right">

          {authState.isLoggedIn ? <>
            <Link to="/logout" className="btn btn-outline-primary mx-4" id="btnLogout">{t('navigation:lnkLogout')}</Link>
          </> : null}          
        </div>
      </div>
    </nav>
  );
};

export default Navbar;